import classNames from "classnames";
import { useAppSelector } from "@/services/store";
import type { FC, ReactNode } from "react";
import { PersonBlock } from "../../Components/PersonBlock";
import { currentPersonSelector } from "../../slice";
import { NoContactsPage } from "../../Components/NoContactsPage";
import { ContactsTabs } from "../ContactsTabs";
import styles from "./styles.module.scss";

type Props = {
  noteManager: ReactNode;
};

export const GeneralNotesTabsContent: FC<Props> = ({ noteManager }) => {
  const currentPerson = useAppSelector(currentPersonSelector);

  if (!currentPerson) return <NoContactsPage message="You have not any chosen contacts yet" />;

  return (
    <div className={styles["notes-tabs-content-root"]}>
      <div className={classNames(styles.container)}>
        <div className={styles["person-block-wrapper"]}>
          <PersonBlock showMobileMenu={false} />
        </div>
        <div className={styles["mobile-tabs"]}>
          <ContactsTabs />
        </div>
        <div className={styles["notes-manager"]}>{noteManager}</div>
      </div>
    </div>
  );
};
